import { DocumentCard, DocumentCardImage, ImageFit } from "@fluentui/react";
import { ShortLineModel } from "../../products/models/ProductModel";
import { ProductUtils } from "../../products/ProductUtils";
import ProductPriceView from "../../products/views/shared/ProductPriceView";

export type HomeProductItemProps = {
    line: ShortLineModel;
    isMobile: boolean;
    onProductDetail: (line: ShortLineModel) => void;
}

export default function HomeProductItemView({ line, isMobile, onProductDetail }: HomeProductItemProps) {
    const url = ProductUtils.getImageUrl(line.imageUrl);
    const vSpacing = isMobile ? "pt-5" : "pt-10";

    return <DocumentCard className="picture-wrapper">
        <div className="pointer" onClick={() => onProductDetail(line)}>
            <DocumentCardImage height={160} imageFit={ImageFit.centerCover}
                className="product-picture image-radius" imageSrc={url} />

            <div className="left font-smaller pt-10">
                <div className={vSpacing}>{line.brand}</div>
                <div className={vSpacing + " limit-lines one-line"} style={{ opacity: 0.7 }}>
                    {line.productName}
                </div>
                <div className={vSpacing + " font-bold"}>
                    <ProductPriceView
                        info={line.printInfo}
                        minPrice={line.minPrice}
                        maxPrice={line.maxPrice}
                    />
                </div>
            </div>
        </div>
    </DocumentCard>;
}